export const addMixin = {
  data() {
		return {
			note: false,
			categoryOptions: [
				{ value: null, text: 'Please select a Category' },
				{ value: 'blender', text: 'Blender 3D' },
				{ value: 'sculpture', text: 'Sculpture' },
				{ value: 'image', text: 'Composite' }
			],
			seriesOptions: [
				{ value: null, text: 'Please select a Series' },
				{
					value: 'Epitome in the Valley Series',
					text: 'Epitome in the Valley Series'
				},
				{
					value: 'Scelanimals Series',
					text: 'Scelanimals Series'
				},
			
				{
					value: 'Vigilante Warrior Series',
					text: 'Vigilante Warrior Series'
				},
				{
					value: 'Epitome Leader Series',
					text: 'Epitome Leader Series'
				},
				{
					value: 'Epitome in Motion Series',
					text: 'Epitome in Motion Series'
				},
				{
					value: 'Anatomical Epitome Series',
					text: 'Anatomical Epitome Series'
				},
				{
					value: 'Hybrid Epitome Series',
					text: 'Hybrid Epitome Series'
				},
				{
					value: 'Molten CyberCreature Series',
					text: 'Molten CyberCreature Series'
				},
				{
					value: 'Tutorial Series',
					text: 'Tutorial Series'
				},
			],
			skillOptions: [
				{ value: null, text: 'Please select a Skill' },
				{
					value: 'Blender, Photography & Composite',
					text: 'Blender, Photography & Composite'
				},
				{
					value: 'Blender Animation',
					text: 'Blender Animation'
				},
				{ value: 'Foil Sculpture', text: 'Foil Sculpture' },
				{ value: 'Clay Sculpture', text: 'Clay Sculpture' },

			]
		}
	},
	methods: {
		onPickFile() {
			this.$refs.fileInput.click()
		},
    onFilePicked (event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file.')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
    },
	}
}